import theme, { size } from '@styles/theme'
import styled from '@emotion/styled'
import GearIconButton from '@elements/GearIconButton'
import AppBarAvatar from '@elements/AppBarAvatar'
import { Toolbar, Tabs } from '@mui/material'
import NavHeading from '@elements/NavHeading'
import BaseAppBar from '@elements/BaseAppBar'
import { PiGear, PiGearSix } from 'react-icons/pi'
import StyledTab from '@elements/Tab'
import HideOnScroll from '@elements/HideOnScroll'

const AppBarContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;

  z-index: 100;
  width: 100%;
  
  border-bottom: 0.5px solid rgba(255,255,255,0.2);
  // background-color: rgba(0,0,0,1);
  ${theme.glassBackgruond(0.9)}
`

const NotificationsToolbar = styled(Toolbar)`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

const NotificationsTopNav = ({ selectedItem, setSelectedItem, scrollTrigger }) => {
  return (
    <HideOnScroll
      scrollTrigger={scrollTrigger}
      direction='down'>
      <AppBarContainer>
        <BaseAppBar>
          <NotificationsToolbar>
            <AppBarAvatar />
            <NavHeading>
              Notifications
            </NavHeading>
            <GearIconButton style={{ visibility: 'hidden' }} />
          </NotificationsToolbar>
        </BaseAppBar>
        {/* <Tabs
          onChange={(e, val) => setSelectedItem(val)}
          aria-label="home view tabs"
          value={selectedItem}>
          <StyledTab label='For You' color={selectedItem === 0 ? 'white' : 'grey'} />
          <StyledTab label='Following' color={selectedItem === 1 ? 'white' : 'grey'} />
        </Tabs> */}
      </AppBarContainer>
    </HideOnScroll>
  )
}

export default NotificationsTopNav
